import { mergeAll } from '../operators/mergeAll';
import { EMPTY } from './empty';
import { popNumber, popScheduler } from '../util/args';
import { scheduled } from '../scheduled/scheduled';
import { from } from './from';
export function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var concurrent = popNumber(args, Infinity);
    var sources = args;
    return !sources.length
        ?
            EMPTY
        : sources.length === 1
            ?
                from(sources[0])
            :
                mergeAll(concurrent)(scheduler ? scheduled(sources, scheduler) : from(sources));
}
//# sourceMappingURL=merge.js.map